import { lazy } from 'react';

import { ReactWebComponent } from '@app/utils/web-components';

const PageRoot = lazy(() => import('@app/components/PageRoot'));
const EmailConfirmation = lazy(() => import('.'));

class EmailConfirmationWebComponent extends ReactWebComponent {
    render() {
        return (
            <PageRoot>
                <EmailConfirmation />
            </PageRoot>
        );
    }
}

customElements.define('email-confirmation', EmailConfirmationWebComponent);
